import styled from 'styled-components';
import { media, space, rems } from '../../ui/helpers';
import { colors } from '../../ui/design-tokens';

const Container = styled.div`
  padding-top: ${space(6)};
  padding-bottom: ${space(6)};

  ${media.min('medium')`
    padding-top: ${space(8)};
    padding-bottom: ${space(8)};
  `};

  h2.title {
    margin-bottom: ${space(6)};
  }

  h3.title {
    margin-bottom: ${space(4)};
  }
`;

const Box = styled.div`
  border-bottom: 1px solid ${colors.neutral[300]};
  cursor: pointer;
  display: flex;
  font-weight: 500;
  justify-content: space-between;
  outline: none;
  padding: ${space(2)} 0;
  text-align: left;
  width: 100%;

  .chevron {
    height: ${rems(10)};
    margin: auto ${rems(13)} auto ${rems(13)};
    transition: 0.6s ease;
    width: ${rems(16)};

    path {
      fill: ${({ theme }) => theme.clickable};
    }
  }

  &.open {
    border-bottom: none;

    .chevron {
      transform: scaleY(-1);
    }
  }

  &:first-of-type {
    border-top: 1px solid ${colors.neutral[300]};
  }
`;

const Panel = styled.div`
  background: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.text};
  overflow: hidden;
  transition: max-height 0.6s ease;

  > div {
    padding: ${space(3)} ${space(3)} ${space(4)};
  }
`;

export { Container, Box, Panel };
